export default "__VITE_PUBLIC_ASSET__8610bc27__"